import { render } from "./MunicipioUf.vue?vue&type=template&id=6ab5c085&ts=true"
import script from "./MunicipioUf.vue?vue&type=script&lang=ts"
export * from "./MunicipioUf.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Municipios/MunicipioUf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ab5c085"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ab5c085', __exports__)) {
    api.reload('6ab5c085', __exports__)
  }
  
  module.hot.accept("./MunicipioUf.vue?vue&type=template&id=6ab5c085&ts=true", () => {
    api.rerender('6ab5c085', render)
  })

}


export default __exports__